
import Vue from 'vue';
import { ExportFormat, TripError } from '@/generated-clients/myTrips';
import { Component, Prop } from 'vue-property-decorator';
import { today } from '@util/dates-and-times';
import { FilterOptions } from '@/utils/types';
import ActiveFiltersList from '@/components/new-styleguide/ActiveFiltersList.vue';
import ErrorBox from '@/components/new-styleguide/ErrorBox.vue';
import DateInput from "@components/new-styleguide/form/DateInput.vue";
import { differenceInYears } from 'date-fns';

export interface ExportModel {
  date: {
    from: string,
    until: string
  }
  email: string,
  exportFormat: ExportFormat
}

@Component({
  name: 'ExportTab',
  components: {
    DateInput,
    ActiveFiltersList,
    ErrorBox
  }
})
export default class ExportTab extends Vue {
  @Prop({ required: true })
  private value: ExportModel;

  @Prop({ required: true })
  private filters: FilterOptions;

  @Prop({ required: true })
  private tripErrors: TripError[];

  @Prop({ default: false })
  private success: boolean;

  @Prop({ default: false })
  private error: boolean;

  private ExportFormat = ExportFormat;

  private handleEmailInput(event) {
    const email = event.target.value;
    this.$emit('input', { ...this.value, email });
  }

  private handleExportFormatInput(event) {
    const exportFormat = event.target.value;
    this.$emit('input', { ...this.value, exportFormat });
  }

  get triplogHasErrors() {
    return !this.filters.categoryFiltersActive && this.tripErrors.length > 0;
  }

  get today() {
    return today()
  }

  get timeSpanExceedsOneYear() {
    const { from, until } = this.value.date || {};

    if (!from || !until) {
      return true;
    }

    const years = differenceInYears(new Date(until), new Date(from));
    return years >= 1;
  }
}
